import React from 'react';

import { Flex, FormField, FormHelp, Label, Paragraph } from '@zillow/constellation';
import { NumberStepper } from '@zillow/zrs-comet';

import type { Section } from '../../../models/index';
import { MAXIMUM_NUMBER_OF_OCCUPANTS } from '../../../constants/index';

type Props = {
  section: Section;
  setSectionValues: (keyValuePairs: object) => void;
};

const MAX_OCCUPANTS = 13;

function MaximumNumberOfOccupants({ section, setSectionValues }: Props) {
  function onMaximumOccupancyChange(value: number): void {
    setSectionValues({
      [MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS]: value,
    });
  }
  const maximumOccupants = Number(
    section.getFieldValue(MAXIMUM_NUMBER_OF_OCCUPANTS.FIELD_NAME.MAXIMUM_NUMBER_OF_OCCUPANTS),
  );

  return (
    <FormField
      label={<Label size="lg">What is the total max occupancy permitted?</Label>}
      control={
        <Flex display="flex" alignItems="center" flexDirection="column">
          <NumberStepper min={1} max={MAX_OCCUPANTS} value={maximumOccupants} onChange={onMaximumOccupancyChange} />
          <Paragraph>total occupants allowed</Paragraph>
        </Flex>
      }
      description={
        maximumOccupants === MAX_OCCUPANTS && (
          <Flex display="flex" alignItems="center" flexDirection="column">
            <FormHelp>{`${MAX_OCCUPANTS} is the maximum`}</FormHelp>
          </Flex>
        )
      }
    />
  );
}

MaximumNumberOfOccupants.description =
  'Allow Irene to set the maximum amount of occupants (tenants + additional occupants).';

export default MaximumNumberOfOccupants;
